class FeaturedProductsSlider {
  constructor(container) {
    this.container = container;
    this.splideInstance = null;
    this.init();
  }

  init() {
    this.handleSplideSlider();
    this.handleWindowResize();
    this.setupCartPageRefresh();
  }

  handleSplideSlider() {
    const cartPageSlider = document.querySelector('.featured-products.cart-page');

    if (window.innerWidth > 992 && !cartPageSlider) return
    const productsSlider = this.container;

    if (productsSlider) {
      if (this.splideInstance) {
        this.splideInstance.destroy(true);
      }

      this.splideInstance = new Splide(productsSlider, {
        perPage: cartPageSlider ? 4 : 1,
        drag: true,
        perMove: 1,
        mobileFirst: true,
        autoplay: 'play',
        arrows: false,
        padding: cartPageSlider ? '' : { right: '100px' },
        pagination: false,
        gap: cartPageSlider ? '36px' : '30px',
        speed: 1000,
        breakpoints: {
          992: {
            centerMode: true,
            perPage: 1,
            padding: cartPageSlider ? '' : { right: '75px' },
            variableWidth: false
          }
        }
        
      }).mount();
    }

    
  }

  handleWindowResize() {
    window.addEventListener("resize", () => {
      if (this.splideInstance) {
        this.splideInstance.destroy(true);
      }
      this.handleSplideSlider();
    });
  }

  setupCartPageRefresh() {
    const cartPage = document.querySelector('.featured-products.cart-page');
    if (cartPage) {
      const addToCartButtons = document.querySelectorAll('.add-to-cart');

      addToCartButtons.forEach((button) => {
        button.addEventListener('click', () => {
          setTimeout(() => {
            location.reload(); 
          }, 2000)
        });
      });
    }
  }
}

document.addEventListener('DOMContentLoaded', function() {
  const featuredProductsSection = document.querySelector('[featured-products-slider]');

  if (featuredProductsSection) {
    new FeaturedProductsSlider(featuredProductsSection);
  }
});

document.addEventListener('shopify:section:load', (event) => {
  const featuredProductsSection = event.target.querySelector('[featured-products-slider]');

  if (featuredProductsSection) {
    new FeaturedProductsSlider(featuredProductsSection);
  }
});


// 

document.addEventListener('DOMContentLoaded', function () {
  initSlidersInVisibleTabs();

  // If using buttons or links to change tabs
  document.querySelectorAll('.tablinks').forEach(tabBtn => {
    tabBtn.addEventListener('click', () => {
      // Wait for the tab content to become visible
      setTimeout(() => {
        initSlidersInVisibleTabs();
      }, 50); // delay to ensure visibility
    });
  });
});

function initSlidersInVisibleTabs() {
  document.querySelectorAll('[featured-products-slider]').forEach(sliderEl => {
    // Skip if already initialized
    if (!sliderEl.classList.contains('splide-initialized') && isVisible(sliderEl)) {
      new FeaturedProductsSlider(sliderEl);
      sliderEl.classList.add('splide-initialized');
    }
  });
}

function isVisible(el) {
  return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
}